import axios from "axios";
const backendUrl = `https://formbot-a0ti.onrender.com`;

export const registerUser = async ({ name, email, password, checkpass }) => {
    try {
       //const reqUrl = `${backendUrl}`;
       await axios.post(`${backendUrl}/register`, {
            name,
            email,
            password,
            checkpass,
        });
        return true;
    } catch (error) {
        console.log(error);
        alert("Something went wrong");
    }
};


export const loginUser = async ({ email, password }) => {
    try {
        const reqUrl = `${backendUrl}/login`;
        const response = await axios.post(reqUrl, {
            password,
            email,
        });
        if (response.data?.token) {
            localStorage.setItem("token", JSON.stringify(response.data?.token));
            localStorage.setItem("name", JSON.stringify(response.data?.name));
            localStorage.setItem(
                "userId", 
                JSON.stringify(response.data?.userId)
            );
        }
        return true;
    } catch (error) {
        console.log(error);
        alert("Something went wrong");
    }
};
